export default "/v8.53.0/42035ef/bundles/opensearch.xml";